import { IDisposable } from "@common/types";
import { HospitalHubStore } from "./HospitalHub";
import { IReactionDisposer, action, computed, makeObservable, observable, when } from "mobx";
import { ExamStore } from "@hospital/views/exam";
import { HubGroupType } from "@common/stores/hubs/BaseHub";

export class ExamMessageHub implements IDisposable {
    messageHub: HospitalHubStore;
    examStore: ExamStore;
    reactionDisposers: IReactionDisposer[] | undefined = undefined;
    @observable private _previousVisitId: number | undefined = undefined;
    @observable private _visitRefreshTick: number = 0;


    constructor(examStore: ExamStore) {
        this.messageHub = HospitalHubStore.currentInstance;
        this.examStore = examStore;
        makeObservable(this, undefined, { autoBind: true });
        this.subscribeToHubEvents();
        this.reactionDisposers = this.initReactions();

    }

    @computed get currentVisitId() {
        return this.examStore.visit?.visitId;
    }

    @computed get visitRefreshTick() {
        return this._visitRefreshTick;
    }

    private subscribeToHubEvents(unsubscribe: boolean = false) {
        const method = !unsubscribe ? this.messageHub.registerMethod : this.messageHub.unregisterMethod;
        method.call(this, { eventName: "onVisitUpdated", callback: this.onVisitUpdated });
    }

    private initReactions(): IReactionDisposer[] {
        return [
            when(() => this.currentVisitId !== this._previousVisitId, async () => {
                if (this._previousVisitId)
                    await this.messageHub.leaveVisitGroup(this._previousVisitId, HubGroupType.VisitExamOpen);
                if (this.currentVisitId) {
                    await this.messageHub.joinVisitGroup(this.currentVisitId, HubGroupType.VisitExamOpen);
                    this._previousVisitId = this.currentVisitId;
                } else
                    this._previousVisitId = undefined;
            })
        ];
    }

    dispose() {
        if (this.currentVisitId)
            this.messageHub.leaveVisitGroup(this.currentVisitId, HubGroupType.VisitExamOpen); //<- notify other connections that this connection left the visit.        
        this.subscribeToHubEvents(true);
        this.reactionDisposers?.forEach(value => value());
    }


    //#region Events
    @action.bound private onVisitUpdated(connectionId: string, visitId: number) {
        if (visitId === this.currentVisitId)
            this._visitRefreshTick = this._visitRefreshTick + 1;
    }
    //#endregion
}
